import { PenType } from './drawingDataModel'

/**
 * 手書き用の情報
 */
export namespace DrawSettings {
  /**
   * 描画方法の定義値(context.globalCompositeOperationに使用する値)
   */
  export class Operations {
    /** 通常描画(上書き) */
    static readonly WRITE_OVER = 'source-over'
    /** 消去 */
    static readonly REMOVE_OVER = 'destination-out'
  }

  /**
   * 線端の見た目(context.lineCapに使用する値)
   */
  export class LineCap {
    /** 円形(丸いペン) */
    static readonly ROUND = 'round'
    /** 四角形(四角いペン) */
    static readonly SQUARE = 'square'
  }

  /**
   * 線接合の形状(context.lineJoinに使用する値)
   */
  export class LineJoin {
    /** 丸くする */
    static readonly ROUND = 'round'
    /** 面取りする */
    static readonly BEVEL = 'bevel'
    /** 面取りしない */
    static readonly MITER = 'miter'
  }

  /**
   * ペン情報の型定義
   */
  export type PenAsset = {
    /** ペン定義名 */
    name: PenType
    /** 描画タイプ(Operationsの定義値を使用) */
    operation: string
    /** ペンの種類(LineCapの定義値を使用) */
    lineCap: CanvasLineCap
    /** 線の幅(太さ) */
    lineWidth: number
    /** ペンの色(カラーコード) */
    color?: string
    /** 透明度(0〜1) */
    alpha?: number
  }

  /**
   * 手書きキャンバスのペン情報の型定義
   */
  export type TegakiPenAsset = {
    /** ペンの種類(LineCapの定義値を使用) */
    lineCap: CanvasLineCap
    /** 線接合の種類（LineJoinの定義値を使用） */
    lineJoin: CanvasLineJoin
    /** 線の幅(太さ) */
    lineWidth: number
    /** ペンの色(カラーコード) */
    color: string
  }

  /**
   * 手書きキャンバスのモード定義
   */
  export type TegakiMode = 'pen' | 'eraser'
}
